export default __webpack_public_path__ + "static/media/ri_question-line_1.88d64a90.svg";